<div class="dialog-title">
  Select 3D Tour
</div>

<mat-card class="core-list">
  <mat-list>
    <mat-list-item *ngFor="let link of virtualModel" (click)="goTour(link)">
      <div matLine class="xsTitle-f">{{link.caption}}</div>
      <div matLine class="xsDesc-f">{{link.url}}</div>
      <mat-icon>
        chevron_right
      </mat-icon>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-list>
</mat-card>
